module.exports = __webpack_public_path__ + "img/vehiculo.81fcd774.svg";